module.exports = __webpack_public_path__ + "static/media/lotto.44ad77ec.jpeg";